export enum RateSheetType {
  FLAG_DOWN = 'FLAG_DOWN',
  TEUS = 'TEUS',
  LOAD_BASED = 'LOAD_BASED',
  COMMITMENT = 'COMMITMENT',
  MATRIX = 'MATRIX',
  LOCATION_BASED = 'LOCATION_BASED',
  WEIGHT_BASED = 'WEIGHT_BASED',
  QUANTITY_BASED = 'QUANTITY_BASED',
  VEHICLE_CATEGORY_BASED = 'VEHICLE_CATEGORY_BASED',
  FREEZER = 'FREEZER'
}
